module.exports = __webpack_public_path__ + "assets/img/3.7c4b8fa3.jpg";